import { render, staticRenderFns } from "./IngredientTableCsvDownload.vue?vue&type=template&id=3a42020a&"
import script from "./IngredientTableCsvDownload.vue?vue&type=script&lang=ts&"
export * from "./IngredientTableCsvDownload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports